//เพิ่มสิทธิประโยชน์ หน้า สิทธิพิเศษ
import React, { useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { FontAwesome, FontAwesome5 } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import ManageGroups from "./manageGroups";
import { useRecoilValue } from "recoil";
import { univer } from "../reducer";
import { apiservice } from "../service/api";
import { addImage } from "../utils";

const { width, height } = Dimensions.get("window");

const addGroups = ({ setpages, state }) => {
  const [page, setpage] = useState(0);
  const [data, setdata] = useState(false);
  const university = useRecoilValue(univer);
  const [body, setBody] = useState(state);

  async function onPress() {
    const res = await apiservice({
      path: "/group/update",
      method: "put",
      body: { ...body, university_id: university.id },
    });
    if (res.status == 200) {
      setpages(0);
    }
  }

  // async function onPress() {
  //   const res = await apiservice({
  //     path: "/group/update",
  //     method: "put",
  //     body: { ...body, item: university.id },
  //   });
  //   if (res.status == 200) {
  //     setpages(0);
  //   }
  // }
  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
          }}
        >
          <ScrollView>
            <Text
              style={{
                width: width * 0.591,
                fontSize: 18,
                fontFamily: "Prompt-Regular",
                color: "#202020",
                marginTop: 30,
              }}
            >
              เพิ่มกลุ่ม
            </Text>

            <View
              style={{
                borderWidth: 0.591,
                borderColor: "#002377",
                width: width * 0.591,
                marginVertical: 10,
              }}
            ></View>

            <View style={{ width: width * 0.591, height: height * 0.546 }}>
              <View
                style={{
                  width: 200,
                  height: 200,
                  borderWidth: 0.5,
                  borderRadius: 5,
                  borderColor: "#00237750",
                  marginVertical: 15,
                }}
              >
                <Image
                  style={{ width: 200, height: 200 }}
                  source={{ uri: body.image_url[0] }}
                />
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: "Prompt-Regular",
                    color: "#ccc",
                  }}
                >
                  ควรอัพโหลดรูปภาพขนาด 1:1
                </Text>
              </View>

              <View
                style={{
                  width: width * 0.235,
                  height: height * 0.037,
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    width: width * 0.8,
                    height: height * 0.037,
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    borderWidth: 1,
                    overflow: "hidden",
                    borderColor: "#00237740",
                    paddingLeft: 5,
                    fontFamily: "Prompt-Regular",
                    fontSize: 12,
                  }}
                />
                <TouchableOpacity
                  onPress={async () => {
                    const res = await addImage();
                    setBody((val) => ({ ...val, image_url: [res] }));
                  }}
                  style={{
                    width: width * 0.05,
                    height: height * 0.037,
                    backgroundColor: "#002377",
                    borderTopRightRadius: 5,
                    borderBottomRightRadius: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: "Prompt-Regular",
                      color: "#ffff",
                      margin: "auto",
                    }}
                  >
                    อัพโหลดรูป
                  </Text>
                </TouchableOpacity>
              </View>

              <View style={styles.Boxarea}>
                <Text style={styles.Text18}>ชื่อกลุ่ม</Text>
                <TextInput
                  value={body.name}
                  onChangeText={(text) => {
                    setBody((val) => ({ ...val, name: text }));
                  }}
                  style={styles.TextInput1}
                />
              </View>
              <View
                style={{
                  width: width * 0.25,
                  height: height * 0.037,
                  flexDirection: "row",
                  alignItems: "center",
                  marginVertical: 10,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setBody((val) => ({ ...val, addgroup: !val.addgroup }));
                  }}
                >
                  {body.addgroup ? (
                    <FontAwesome5
                      name="check-square"
                      size={20}
                      color="#74B4E3"
                    />
                  ) : (
                    <FontAwesome5 name="square" size={20} color="#74B4E3" />
                  )}
                </TouchableOpacity>
                <Text style={[styles.Text18, { marginLeft: 10 }]}>
                  เพิ่มกลุ่มย่อย
                </Text>
              </View>
              <View style={styles.Boxareabutton}>
                <TouchableOpacity
                  onPress={onPress}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#69D443",
                    marginRight: 20,
                  }}
                >
                  <Text style={styles.TextButton}>ยืนยัน</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={() => setpage(1)}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#D44343",
                  }}
                >
                  <Text style={styles.TextButton}>ยกเลิก</Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </View>
      )}
      {page == 1 && <ManageGroups />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.25,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginVertical: 15,
  },
  Boxare1: {
    width: width * 0.53,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginVertical: 15,
  },
  Boxareabutton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 20,
  },
  Text18: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextInput: {
    width: width * 0.182,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 16,
    fontFamily: "Prompt-Regular",
  },
  TextInput1: {
    width: width * 0.2,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 16,
    fontFamily: "Prompt-Regular",
  },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default addGroups;
